import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { serverError } from './../../../../core/models/messages';
import { OffreEsnService } from './../../../../core/services/offre-esn/offre-esn.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, State } from 'country-state-city';
import { translations } from '../../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
@Component({
  selector: 'app-archived-esn-offer',
  templateUrl: './archived-esn-offer.component.html',
  styleUrls: ['./archived-esn-offer.component.css'],
})
export class ArchivedEsnOfferComponent implements OnInit {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  freeSearchActive :boolean = false;
  isFormSubmitted: boolean = false;
  freeSearch: boolean = false;
  isFreeSearchFromSubmitted: boolean = false;
  btnSearchactive : boolean = false;
  dataHeader: any = [];
  listNames: string[] = [];
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  private unsubscribeAll: Subject<void> = new Subject();
  connectedUser = this.localStorageService.getData('userConnected');
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  loadSpinner: boolean = false;
  pagination : boolean =false;
  typeintervenant: any;
  idclientConnected: any;
  itemsPerPage: number = 5;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentPage: number = 0;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  totalItems!: number;
  listappeloffre: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  sortAttr = '';
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList: any = [];
  mobilities: any[] = [];
  isCollapsed = true;
  idCompany:any
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  status = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by

  currentUser: any;
  userId: any;
  constructor(
    private formBuilder: FormBuilder,
    private offreesnservice: OffreEsnService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private appelofferservice: EsnAppeloffreService
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();
    this.getListoffrebesoinesnarchived();
    this.getListSkills();
    this.getListElementHeader();
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });

    this.currentUser = this.localStorageService.getData('UserInfo');
    this.userId = JSON.parse(this.currentUser)?.uuid
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}') 
    this.idCompany = connectedUser?.company?.uuid
  }
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9\/]/g, '');
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    if(Array.isArray(contractTypes)) return contractTypes?.map(type => contractMap[type.toString()] || '').join(', ');
    else return ''
  }
  getRemainingPays(pay: any): string {
    if (!Array.isArray(pay) || pay.length <= 3) {
      return ''; 
    }
    return pay.map(m => String(m)).join(', '); 
  }

  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);

        });
      }*/
    }
  }

  getListElementHeader() {
    this.offreesnservice.getHeaderElements(31)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => { },
      });
  }
  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
    };
    this.offreesnservice
      .changeDelectedElementHeader(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: () => { },
        error: () => { },
      });
  }
  getSkillsArray(offre: any): string[] {
    if (offre && offre.skills) {
      return offre.skills.split(',').map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  getSkillsList(skills: string): string {
    if (!skills) {
      return '';
    }
    return skills.split(',').map(s => s.trim()).join(', ');
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  getListoffrebesoinesnarchived() {
    const params = {
      per_page: this.pageSize,
      page: this.currentPage}   
    this.spinner.show();

    this.offreesnservice.getListoffrebesoinesnarchived(params).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          const { to, from, total, current_page, data } = response.data;
          this.spinner.hide();
          this.totalItems = response.data.total;
          this.listappeloffre = response.data.data;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  convertKToNumber(value: any) {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      return parseFloat(value.slice(0, -1)) * 1000;
    } else if (!isNaN(value)) {
      return parseFloat(value) * 1000;
    }
    return parseFloat(value);
  }

  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobOffer: ['', data?.ID_jobOffer],
      name: ['', data?.name],
      esn_name: ['', data?.esn_name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],

      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      contract_type: [[], data?.contract_type],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      city: [[], data?.city],
      country: [[], data?.country],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      state: [null, data?.state],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
    });
  }

  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
      this.activeForm = form;
      if (form === 'freeSearch') {
        this.freeSearchActive = true;
        this.freeSearchForm.enable(); 
      } else if (form === 'guidedSearch') {
        this.freeSearchActive = false;
        this.searchForm.enable();
      }
  }

  // resetFreeSearch() {
  //   this.currentPage = 1;
  //   this.freeSearchForm.reset();
  //   this.freeSearchForm = this.createFreeSearchForm();
  //   this.freeSearchForm.get('search')?.reset();
  //   this.isFreeSearchFromSubmitted = false;
  // }

  // resetAdvancedSearch() {
  //   this.currentPage = 1;
  //   this.searchForm.reset();
  //   this.isFormSubmitted = false;
  // }
  onReset() {
    this.stateList=[];
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.btnSearchactive = false;
    this.freeSearchActive = false;
    this.getListoffrebesoinesnarchived();
  }
  onSubmit() {
    this.btnSearchactive = true;
    if(!this.freeSearchActive) {
      this.currentPage = 0;
      this.searchoffrebesoinesn(this.currentPage);
    } else{
      this.currentPage = 0;
      this.freeSearchOffreBesoinEsn(this.currentPage);
    }
  }

  freeSearchOffreBesoinEsn(pageNumber: number = this.currentPage) {
    this.isFormSubmitted = false;
    this.isFreeSearchFromSubmitted = true;
    let valueForm = this.freeSearchForm.value;
    let data = {
      page: this.currentPage + 1,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.offreesnservice.freeSearchoffrebesoinesnarchived(data).subscribe({
          next: (resSearch) => {
              this.listappeloffre = resSearch.data.data;
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }

  /* search */
  searchoffrebesoinesn(pageNumber : number = this.currentPage) {
    this.isFreeSearchFromSubmitted = false;
    this.isFormSubmitted = true;
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range?.toString()
    );
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');

    let data = {
      id: this.userId,
      ID_jobOffer: valueForm.ID_jobOffer,
      name: valueForm.name,
      esn_name: valueForm.esn_name,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      contract_type: valueForm.contract_type,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: valueForm.desired_salary_range,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      post_type: valueForm.post_type,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      city: valueForm.city,
      country: valueForm.country,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      state: valueForm.state,
      page: this.currentPage + 1,
      per_page: this.pageSize,
    };

    this.spinner.show();
    this.offreesnservice.searchoffrebesoinesnarchived(data).subscribe({
      next: (resSearch) => {
        if (resSearch.status == 200) {
          this.spinner.hide();
          this.totalItems =  resSearch.data.total;
          this.listappeloffre = resSearch.data.data ;
          }
        this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
    if(this.btnSearchactive){
      if(this.freeSearchActive) {
        this.freeSearchOffreBesoinEsn(this.currentPage);
      } else {
        this.searchoffrebesoinesn(this.currentPage);
      }
    }else{
      this.getListoffrebesoinesnarchived();
    }
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  restaureroffrebesoinesn(id: any) {




    this.offreesnservice
          .restaureroffrebesoinesn(id, this.idCompany)
          .subscribe({
            next: (response: any) => {
              if (response.data) {
                this.toastrService.success(
                  'L’offre d’emploi a été restauré avec succès.'
                );
                this.searchoffrebesoinesn();
                // this.route.navigateByUrl("/esn-offres-emploi/list-offres")
              }
            },
            error: (error: any) => {
            },
          });
    // Swal.fire({
    //   title: 'Vous êtes sûr de restaurer l’offre sélectionnée ?',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085D6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Oui, restaurer !',
    //   cancelButtonText: 'Annuler',
    // }).then((result) => {
    //   if (result.isConfirmed) {
        
    //   }
    // });
  }
  reset() {
    this.searchForm.reset();
    this.isFormSubmitted = false;
    this.searchForm = this.createSearchForm();
    this.currentPage = 1;
    this.getListoffrebesoinesnarchived();

  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
      this.searchForm = this.createSearchForm();
      this.searchForm.reset();
      this.getListoffrebesoinesnarchived();
   }
   else {
     this.freeSearchForm.reset();
     this.freeSearchForm = this.createFreeSearchForm();
     this.getListoffrebesoinesnarchived();
   }
  }
  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
}